import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { QuestionBase } from './question-base';

@Injectable()
export class QuestionControlService {
  constructor(private fb: FormBuilder) {}

  toFormGroup(questions: QuestionBase<any>[], action?: string) {
    return this.fb.group(this.getGroup(questions, action));
  }

  private getGroup(questions: QuestionBase<any>[], action?: string) {
    const group: any = {};
    questions.forEach((question) => {
      if (question.controlType !== 'group') {
        group[question.key] = this.fb.control(question.value || '', this.getValidators(question));
        question.disabled ? group[question.key].disable() : group[question.key].enable();
        if (question.childQuestions) {
          Object.assign(group, this.getGroup(question.childQuestions, action));
        }
      } else if (question.key) {
        group[question.key] = this.fb.group(this.getGroup(question.childQuestions, action));
      } else {
        Object.assign(group, this.getGroup(question.childQuestions, action));
      }
    });
    return group;
  }

  validateCheckbox(formGroup, question) {
    return formGroup.value
      ? null
      : {
          validateCheckbox: {
            valid: false
          }
        };
  }

  getValidators(question: any) {
    const validators = [];
    if (question.validators) {
      if (question.validators.required) {
        if (question.controlType === 'checkbox') {
          validators.push(this.validateCheckbox);
        } else {
          validators.push(Validators.required);
        }
      }
      if (question.validators.number) {
        validators.push(Validators.pattern(/^[0-9]*$/));
      }
      if (question.validators.mail) {
        const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        validators.push(Validators.pattern(EMAIL_REGEXP));
      }
      if (question.validators.videoMediaUrl) {
        // Allow urls from 'youtube' and 'vimeo'
        const VIDEO_MEDIA_REGEXP =
          /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        validators.push(Validators.pattern(VIDEO_MEDIA_REGEXP));
      }
      if (question.validators.minLength) {
        validators.push(Validators.minLength(question.validators.minLength));
      }
      if (question.validators.maxLength) {
        validators.push(Validators.maxLength(question.validators.maxLength));
      }
      if (question.validators.minDate) {
        // TODO The check is done in the date component (question-datepicker), but it should also be checked here
      }
      if (question.validators.maxDate) {
        // TODO The check is done in the date component (question-datepicker), but it should also be checked here
      }
      if (question.validators.maxValue) {
        validators.push((formControl: FormControl<any>) =>
          formControl.value > question.validators.maxValue.limit
            ? { maxValue: { limit: question.validators.maxValue.limit } }
            : null
        );
      }
      if (question.validators.minValue) {
        validators.push((formControl: FormControl<any>) =>
          formControl.value < question.validators.minValue.limit
            ? { minValue: { limit: question.validators.minValue.limit } }
            : null
        );
      }
      if (question.validators.function) {
        validators.push(question.validators.function);
      }
      if (question.validators.regexp) {
        validators.push(Validators.pattern(question.validators.regexp));
      }
    }

    return Validators.compose(validators);
  }
}
